// Width ÷ height of each picture, the same shapes the customer app draws (src/styles/picture-shapes.ts there),
// saved large enough to stay sharp on a 3x phone screen.
export const PICTURE_SHAPES = {
  banner: { aspectRatio: 2, recommendedSizeText: "1200 × 600", compressMaxRes: 1200, lockShape: true },
  square: { aspectRatio: 1, recommendedSizeText: "800 × 800", compressMaxRes: 800, lockShape: true },
  product: { aspectRatio: 1, recommendedSizeText: "800 × 800", compressMaxRes: 800, lockShape: true },
  restaurant: { aspectRatio: 94 / 76, recommendedSizeText: "470 × 380", compressMaxRes: 470, lockShape: true },
};
